module.exports = __webpack_public_path__ + "static/media/cachureos.afe50fb2.jpg";